var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.row["key"]))]),_vm._l((_vm.$parent.languages),function(l,i){return _c('td',{key:i},[_vm._v(_vm._s(_vm.row[l]))])}),_c('td',[_c('Loader',{attrs:{"id":_vm.row['key']}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }